// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"0450c10f","681":"e75e9574"}[chunkId] + ".chunk.js";
};